import React, {memo, ReactElement} from 'react';

import * as S from './PageWithSidebar.styles';

type PageWithSidebarProps = {
  sidebar: ReactElement;
  children: ReactElement;
  sidebarStyle?: Record<string, string>;
  contentStyle?: Record<string, string>;
};

const PageWithSidebarComp = ({
  sidebar,
  children,
  sidebarStyle,
  contentStyle,
}: PageWithSidebarProps) => {
  return (
    <S.PageWithSidebar>
      <S.Sidebar style={sidebarStyle}>{sidebar}</S.Sidebar>
      <S.Content style={contentStyle}>{children}</S.Content>
    </S.PageWithSidebar>
  );
};

export const PageWithSidebar = memo(PageWithSidebarComp);
